/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VlcrProvisionEdr } from './vlcrProvisionEdr';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ByolEdr } from './byolEdr';
import { EdrOrgRequester } from './edrOrgRequester';


export interface RansomwareRecoveryActivationSpec { 
    /**
     * VLCR org id
     */
    vlcr_org_id?: string;
    vlcr_provider?: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    vlcr_region?: string;
    byol?: ByolEdr;
    requester?: EdrOrgRequester;
    vlcr_provisioned?: VlcrProvisionEdr;
}
export namespace RansomwareRecoveryActivationSpec {
}


